module.exports = __webpack_public_path__ + "static/img/card1.3d97620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/card1.jpg
// module id = biyH
// module chunks = 1